import React, { Component } from "react";
import SomethingWentWrong from "../notices/SomethingWentWrong";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      info: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error,
    };
  }

  componentDidCatch(error, info) {
    console.error(info, error);
    return null;
  }

  render() {
    if (this.state.hasError) return <SomethingWentWrong errors={{statusText: this.state.error.message, status: 'Something went wrong.'}} />;

    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/features/shared/components/layouts/ErrorBoundary.js